var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0063 1.64105L21.1704 9.50342L32.874 21.2465L40.7099 13.3841C42.8906 11.1961 42.8906 7.64562 40.7099 5.45756L36.9062 1.64105C34.7255 -0.547017 31.187 -0.547017 29.0063 1.64105Z",
    fill: "url(#paint0_linear_9060_7243)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63553 37.0309L5.43918 40.8474C7.61988 43.0355 11.1584 43.0355 13.3391 40.8474L21.175 32.985L9.47142 21.2419L1.63553 29.1043C-0.545175 31.2924 -0.545175 34.8428 1.63553 37.0309Z",
    fill: "url(#paint1_linear_9060_7243)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9062 40.8474L40.7099 37.0309C42.8906 34.8428 42.8906 31.2924 40.7099 29.1043L32.874 21.2419L21.1704 32.985L29.0063 40.8474C31.187 43.0355 34.7255 43.0355 36.9062 40.8474Z",
    fill: "url(#paint2_linear_9060_7243)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43918 1.64105L1.63553 5.45756C-0.545175 7.64562 -0.545175 11.1961 1.63553 13.3841L9.47142 21.2465L21.175 9.50342L13.3391 1.64105C11.1584 -0.547017 7.61988 -0.547017 5.43918 1.64105Z",
    fill: "url(#paint3_linear_9060_7243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9060_7243",
    x1: 27.7253,
    y1: 46.7226,
    x2: 22.3048,
    y2: -0.544909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#31A9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9060_7243",
    x1: 8.46948,
    y1: 48.674,
    x2: 3.04896,
    y2: 1.40653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#008966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2EB692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9060_7243",
    x1: 3.23213,
    y1: 27.4575,
    x2: 50.3487,
    y2: 22.0906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9F6192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#723B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9060_7243",
    x1: 1.28728,
    y1: 8.13653,
    x2: 48.4038,
    y2: 2.76965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F26836"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.04f75db40016cb49c2c084ad73eda00f.svg";
export { ForwardRef as ReactComponent };